import React, { useEffect, useState } from 'react';
import Logo from './../assets/images/logo_auth.png';
import LogoLogin from './../assets/images/informasi-harga.png';
import { useDispatch } from 'react-redux';
import ClipLoader from 'react-spinners/ClipLoader';
import { useHistory, useLocation } from 'react-router-dom';
import { API } from '../api/api';
import { loginFailed, visitLoginPage } from '../services/amplitude';
import axios from 'axios';
import FormLogin from '../components/FormLogin';
import { LOGIN_PAGE_DESC } from '../constant/title';
import Grid from '@mui/material/Grid2';
import MainBox from '../components/MainBox';
import { showLoginError, showLoginSuccess } from '../utils/bootstrapUI';
import { requestLoginSuccess } from '../utils/auth';

import ActionLoginSocial from '../components/ActionLoginSocial';
import { Alert, Snackbar } from '@mui/material';

const Login = () => {
  const dispatch = useDispatch();

  const [login, setLogin] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState({
    email: false,
    password: false,
    loginGoogle: null
  });
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false)

  let history = useHistory();
  const { state, search } = useLocation();

  const searchParams = new URLSearchParams(search);
  console.log('searchParams', searchParams.get('nextPath'));

  const onLogin = async () => {
    setIsLoadingSubmit(true)

    dispatch({ type: 'SET_SUBMITTED_EMAIL', value: login.email });

    try {
      const nextPath = searchParams.get('nextPath')

      const res = await axios
        .post(API.login, {
          username: login.email,
          password: login.password,
        })

      if (res.data.status !== 1) {
        throw res
      }

      requestLoginSuccess(res.data.data)
      showLoginSuccess()

      localStorage.setItem('login_with', 'api')

      window.location.href = nextPath ?? '/'

    } catch (error) {
      let axiosError = error

      if (axiosError.response) {
        axiosError = error.response.data.errors
      }
      else {
        axiosError = error.data
      }

      loginFailed(axiosError.message, 'email', login.email, 'Login Page');
      showLoginError(axiosError.message)
    } finally {
      setIsLoadingSubmit(false)
    }
  };



  const onChange = (event) => {
    if (event.target.name == 'email') {
      setLogin({ ...login, email: event.target.value });
      event.target.value == '' ? setError({ ...error, email: true }) : setError({ ...error, email: false });
    } else if (event.target.name == 'password') {
      setLogin({ ...login, password: event.target.value });
      event.target.value == '' ? setError({ ...error, password: true }) : setError({ ...error, password: false });
    }
  };

  useEffect(() => {
    state && visitLoginPage(state.pageChannel);
  }, []);

  const closeAlertGoogle = () => {
    setError(prev => ({
      ...prev,
      loginGoogle: null
    }))
  }
  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        autoHideDuration={3000}
        open={Boolean(error.loginGoogle)}
        onClose={() => closeAlertGoogle()}
      >
        <Alert
          severity="error"
          variant="filled"
          sx={{ width: '100%' }}
          onClose={() => closeAlertGoogle()}
        >
          Can't login google. Error: {typeof error.loginGoogle === 'object' ? JSON.stringify(error.loginGoogle) : error.loginGoogle}
        </Alert>
      </Snackbar>

      <div className="page">
        <MainBox>
          <Grid container>
            <Grid size={{
              lg: 8,
              md: 12,
            }}>
              <div className="px-5 pt-5 mt-5">
                <img width="80" src={Logo} alt="MAP" />
                <h3 className="mt-3 text-light">Market Auction Price</h3>
                <p className="mt-3 pr-5 text-light" dangerouslySetInnerHTML={{ __html: LOGIN_PAGE_DESC }} />
              </div>
            </Grid>
            <Grid size={{
              lg: 4,
              md: 12
            }} sx={{
              padding: '1.5rem 2rem'
            }}>
              {(isLoadingSubmit) && (
                <div className="form-group form-login bg-white rounded d-flex justify-content-center align-items-center  py-5 h-100">
                  <ClipLoader loading size={100} />
                </div>
              )}
              {(!isLoadingSubmit) && (
                <div className="form-group form-login bg-white rounded py-3 px-4">
                  <h4 className="mb-4">Masuk</h4>
                  <FormLogin
                    errors={error}
                    formOnChange={(event) => {
                      onChange(event);
                    }}
                    login={login}
                    onLogin={onLogin}
                  />

                  <ActionLoginSocial
                    onFailure={(errors => {
                      setError(prev => ({
                        ...prev,
                        loginGoogle: errors
                      }))
                    })}
                    onSuccess={() => {
                      setIsLoadingSubmit(false)
                    }}
                    onClick={() => {
                      localStorage.setItem('login_with', 'google')
                      setIsLoadingSubmit(true)
                    }} />
                </div>
              )}
            </Grid>
          </Grid>
        </MainBox>
      </div>
      <div className="page-mobile">
        <div className="container-fluid">
          <div className="row d-flex justify-content-center pt-5" style={{ backgroundColor: '#f0f0f0' }}>
            <img alt='Login MAP' style={{ width: '80%', height: '60%' }} src={LogoLogin} />
          </div>
          <div className="row pt-3">
            <div className="col-12 mt-2">
              <h4 className="mb-4">Masuk</h4>
              <FormLogin
                errors={error}
                formOnChange={(event) => {
                  onChange(event);
                }}
                login={login}
                onLogin={onLogin}
              />

              <ActionLoginSocial onSuccess={() => {
                setIsLoadingSubmit(false)
              }} onClick={() => {
                setIsLoadingSubmit(true)
              }} />

            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
